import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import { ArrowLeft, UserPlus, Mail } from 'lucide-react';
const UserCreate = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    nome: '',
    cognome: '',
    email: '',
    luogo: '',
    obiettivi: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Simulate user creation
    alert(`Utente creato con successo!\n\nNome: ${formData.nome} ${formData.cognome}\nEmail: ${formData.email}\n\nUn'email di invito è stata inviata all'utente.`);
    navigate('/users');
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <div className="flex h-screen bg-gray-50" data-id="element-3593">
      <div className="w-20 flex-shrink-0" data-id="element-3594">
        <Sidebar data-id="element-3595" />
      </div>

      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-3596">
        <Topbar data-id="element-3597" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6" data-id="element-3598">
          {/* Back Button */}
          <button onClick={() => navigate('/users')} className="flex items-center text-gray-600 hover:text-greenback mb-4 transition-colors" data-id="element-3599">
            <ArrowLeft className="h-4 w-4 mr-2" data-id="element-3600" />
            Torna agli Utenti
          </button>

          {/* Page Header */}
          <div className="mb-6" data-id="element-3601">
            <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-3602">
              Aggiungi Nuovo Utente
            </h1>
            <p className="text-gray-600" data-id="element-3603">
              Invita un nuovo utente sulla piattaforma Greenback
            </p>
          </div>

          {/* Form */}
          <div className="bg-white rounded-lg border border-gray-200 p-6 max-w-2xl" data-id="element-3604">
            <form onSubmit={handleSubmit} className="space-y-6" data-id="element-3605">
              {/* Nome e Cognome */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-3606">
                <div data-id="element-3607">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-3608">
                    Nome <span className="text-red-500" data-id="element-3609">*</span>
                  </label>
                  <input type="text" name="nome" value={formData.nome} onChange={handleChange} required placeholder="Es. Mario" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-greenback focus:border-transparent" data-id="element-3610" />
                </div>

                <div data-id="element-3611">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-3612">
                    Cognome <span className="text-red-500" data-id="element-3613">*</span>
                  </label>
                  <input type="text" name="cognome" value={formData.cognome} onChange={handleChange} required placeholder="Es. Rossi" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-greenback focus:border-transparent" data-id="element-3614" />
                </div>
              </div>

              {/* Email */}
              <div data-id="element-3615">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-3616">
                  Email <span className="text-red-500" data-id="element-3617">*</span>
                </label>
                <input type="email" name="email" value={formData.email} onChange={handleChange} required placeholder="mario.rossi@email.it" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-greenback focus:border-transparent" data-id="element-3618" />
                <p className="text-sm text-gray-500 mt-1" data-id="element-3619">
                  L'utente riceverà un'email di invito a questo indirizzo
                </p>
              </div>

              {/* Luogo */}
              <div data-id="element-3620">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-3621">
                  Città
                </label>
                <input type="text" name="luogo" value={formData.luogo} onChange={handleChange} placeholder="Es. Milano" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-greenback focus:border-transparent" data-id="element-3622" />
              </div>

              {/* Obiettivi */}
              <div data-id="element-3623">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-3624">
                  Obiettivi Sostenibilità
                </label>
                <select name="obiettivi" value={formData.obiettivi} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-greenback focus:border-transparent" data-id="element-3625">
                  <option value="" data-id="element-3626">Seleziona un obiettivo...</option>
                  <option value="Ridurre plastica" data-id="element-3627">Ridurre plastica</option>
                  <option value="Vita sostenibile" data-id="element-3628">Vita sostenibile</option>
                  <option value="Zero waste" data-id="element-3629">Zero waste</option>
                  <option value="Cosmetici naturali" data-id="element-3630">Cosmetici naturali</option>
                  <option value="Mobilità green" data-id="element-3631">Mobilità green</option>
                  <option value="Alimentazione bio" data-id="element-3632">Alimentazione bio</option>
                  <option value="Energia rinnovabile" data-id="element-3633">
                    Energia rinnovabile
                  </option>
                  <option value="Ridurre sprechi" data-id="element-3634">Ridurre sprechi</option>
                  <option value="Vita green" data-id="element-3635">Vita green</option>
                  <option value="Riciclo attivo" data-id="element-3636">Riciclo attivo</option>
                </select>
              </div>

              {/* Info Box */}
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4" data-id="element-3637">
                <div className="flex items-start gap-3" data-id="element-3638">
                  <Mail className="h-5 w-5 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-3639" />
                  <div data-id="element-3640">
                    <h4 className="font-semibold text-blue-900 mb-1" data-id="element-3641">
                      Email di Invito
                    </h4>
                    <p className="text-sm text-blue-700" data-id="element-3642">
                      Dopo aver creato l'utente, verrà inviata automaticamente
                      un'email di invito con le istruzioni per accedere alla
                      piattaforma Greenback.
                    </p>
                  </div>
                </div>
              </div>

              {/* Actions */}
              <div className="flex gap-3 pt-4" data-id="element-3643">
                <button type="button" onClick={() => navigate('/users')} className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-3644">
                  Annulla
                </button>
                <button type="submit" className="flex items-center gap-2 px-6 py-2 bg-greenback text-white rounded-lg hover:bg-green-700 transition-colors" data-id="element-3645">
                  <UserPlus className="h-4 w-4" data-id="element-3646" />
                  Crea Utente e Invia Invito
                </button>
              </div>
            </form>
          </div>
        </main>
      </div>
    </div>;
};
export default UserCreate;